import { produce } from 'immer'
import { AppActionTypes } from '../constant'

export type AppReducerState = {
  interstitial_count: number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  productsSub: Array<any> | null
  openBar: boolean
}

const initialState = {
  interstitial_count: 0,
  productsSub: null,
  openBar: false
}

export const appReducer = (state: AppReducerState = initialState, action: Action) =>
  produce(state, draft => {
    switch (action.type) {
      case AppActionTypes.INCREMENT_INTERSTITIAL:
        draft.interstitial_count = draft.interstitial_count + 1
        return
      case AppActionTypes.RESET_INTERSTITIAL:
        draft.interstitial_count = 0
        return
      case AppActionTypes.DEFINE_PRODUCT:
        draft.productsSub = action.payload.products
        return
      case AppActionTypes.DEFINE_OPEN_BAR:
        draft.openBar = action.payload.openBar
        return
    }
  })

type Action =
  | { type: 'INCREMENT_INTERSTITIAL' }
  | { type: 'RESET_INTERSTITIAL' }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  | { type: 'DEFINE_PRODUCT'; payload: { products: Array<any> } }
  | { type: 'DEFINE_OPEN_BAR'; payload: { openBar: boolean } }
